import React, { ReactElement, ReactNode } from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import { getBackgroundTheme } from '../style';
import styled from '@emotion/styled';

const LoaderContainer = styled('div')<{ customStyle?: React.CSSProperties }>(({ customStyle }) => ({
  width: '90%',
  padding: '5%',
  ...customStyle,
}));

interface SkeletonLoaderProps {
  height?: any;
  width: any;
  speed?: any;
  primaryColor?: any;
  secondaryColor?: any;
  backgroundColor?: any;
  children?: ReactNode;
  customStyle?: React.CSSProperties;
}

const SkeletonLoader = ({
  height,
  width,
  speed,
  primaryColor,
  secondaryColor,
  backgroundColor,
  children,
  customStyle,
}: SkeletonLoaderProps): ReactElement => {
  return (
    <LoaderContainer customStyle={customStyle}>
      <ContentLoader
        height={height}
        width={width}
        speed={speed}
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        primarycolor={primaryColor || getBackgroundTheme().block}
        secondarycolor={secondaryColor || getBackgroundTheme().surface}
        backgroundColor={backgroundColor || getBackgroundTheme().block}
      >
        {children}
      </ContentLoader>
    </LoaderContainer>
  );
};

SkeletonLoader.propTypes = {
  height: PropTypes.any,
  width: PropTypes.any,
  speed: PropTypes.any,
};

SkeletonLoader.defaultProps = {
  speed: 2,
};

export default SkeletonLoader;
